import loadable from '@loadable/component';

export const SearchEventsRefinementsLoadable = loadable(
  () => import('./SearchEventsRefinements'),
  { resolveComponent: (module) => module.SearchEventsRefinements },
);
